import { render, staticRenderFns } from "./game-fps-counter.vue?vue&type=template&id=2bb291b8&scoped=true&"
import script from "./game-fps-counter.vue?vue&type=script&lang=js&"
export * from "./game-fps-counter.vue?vue&type=script&lang=js&"
import style0 from "./game-fps-counter.vue?vue&type=style&index=0&id=2bb291b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb291b8",
  null
  
)

export default component.exports